<template>
	<div class="home">
		<vue-headful
				description="Slumberland est une agence de création graphique et digitale basée à Paris. Elle est fondée, gérée et développée par 3 créatifs associés. Nous accompagnons les entreprises - de la startup aux grands comptes - pour créer des plateformes de communication créatives et pertinentes."
				title="Slumberland : agence de design graphique et digital"
		/>
		<RealisationSection
				:realisationItems="realisationItems"
				class="normal_section"
		></RealisationSection>
	</div>
</template>

<script>

import RealisationSection from "@/components/RealisationSection";

export default {
	name: "Home",
	components: {
		RealisationSection
	},
	data() {
		return {
			title: "Realisation Section",
			realisationItems: [

				{
					id: 0,
					page: "Festival du cinéma américain de Deauville",
					description: "Création identité visuelle, charte graphique et conception des affiches <br/>Pour le Public Système Cinéma",
					image: "card_deauville2020.png"
				},
				{
					id: 1,
					titre: "Dassault Falcon",
					description: "Conception et réalisation du site internet Dassault&nbsp;Falcon",
					lien: "https://dassaultfalcon.com",
					lien_texte: "Site Dassault Falcon",
					image: "card_Dassault.jpg"
				},
				{
					id: 2,
					page: "Sonance audition",
					description: "Design 360°",
					image: "card_sonance.jpg"
				},
				{
					id: 3,
					page: "Société Générale",
					description: "Conception et réalisation de 3 usines à sites",
					image: "card_SG.svg"
				},
				{
					id: 5,
					page: "Création affiches",
					lien_texte: "Découvrir les affiches",
					image: "card_affiches.jpg"
				},
				{
					id: 4,
					titre: "IFCIC",
					description: "Création marque, territoire de style, édition et site internet",
					lien_texte: "Site IFCIC",
					lien: "https://www.ifcic.fr",
					image: "card_ifcic.jpg"
				},
				{
					id: 8,
					titre: "Coin de Mire Cinéma",
					description: "Création identité visuelle, création territoire de style et conception graphique série coffret",
					lien_texte: "Détails à venir",
					image: "card_coindemire.jpg"
				},
				{
					id: 7,
					titre: "Skyfirst",
					description: "Création marque, territoire de style, édition et site internet",
					lien_texte: "Site Skyfirst",
					lien: "https://skyfirst.aero",
					image: "card_skyfirst.jpg"
				},
				{
					id: 6,
					page: "Groupe Ober",
					description: "Conception et réalisation des sites internet du groupe Ober",
					image: "card_ober.jpg"
				},
				{
					id: 9,
					titre: "Baetz & Chardin",
					description: "Création marque, territoire de style, édition et site internet",
					lien_texte: "Site Baetz & Chardin",
					lien: "https://baetzetchardin.fr",
					image: "card_bc.jpg"
				},
				{
					id: 10,
					titre: "Talma",
					description: "Création marque, territoire de style, édition et site internet",
					lien_texte: "Site Talma",
					lien: "https://talma.legal",
					image: "card_talma.jpg"
				}
			]
		};
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use '@/assets/scss/partials/variables' as *;
@use '@/assets/scss/partials/mixins' as *;


.home {
	margin: 0 $padding-simple;
	padding-bottom: $padding-simple;
	padding-top: $padding-double;

	.focus_section {
		margin-top: $padding-simple-neg;
	}

}

</style>
